import { useTranslation } from 'react-i18next';
import { deadlineLabel } from '@/pages/Opportunities/dates';
import type { OpportunityDetail } from '@/pages/Opportunities/types';

export interface OpportunityHistoryProps { item: OpportunityDetail; }
export const OpportunityHistory = ({ item }: OpportunityHistoryProps) => {
    const { t, i18n } = useTranslation('global');
    return <section className="space-y-4">
        {item.events.length === 0 && <p>{t('opportunities.no_events')}</p>}
        {item.events.map(event => <article key={event.id} className="space-y-2 rounded-xl border border-slate-200 p-4 dark:border-white/15">
            <p className="font-semibold">{t(`opportunities.event.${event.action}`)} · {item.actors.find(actor => actor.id === event.actor_id)?.name ?? t('opportunities.system')}</p>
            <time className="text-xs">{deadlineLabel(event.created_at, i18n.language)}</time>
            {event.reason && <p className="whitespace-pre-wrap text-sm">{event.reason}</p>}
            {event.document_ids.length > 0 && <p className="text-xs">{t('opportunities.supporting_documents')}: {event.document_ids.map(id => item.documents.find(file => file.id === id)?.name ?? String(id)).join(', ')}</p>}
            <details><summary className="cursor-pointer text-sm">{t('opportunities.view_changes')}</summary>
                <pre className="max-h-96 overflow-auto whitespace-pre-wrap break-all text-xs">{JSON.stringify(event.changes, null, 2)}</pre>
            </details>
        </article>)}
        {item.legacy_logs.length > 0 && <section className="space-y-2"><h3 className="font-semibold">{t('opportunities.legacy_history')}</h3>
            {item.legacy_logs.map(event => <p key={event.id} className="text-xs">{deadlineLabel(event.created_at, i18n.language)} · {event.action} · {event.notes}</p>)}
        </section>}
    </section>;
};
